import { keysToCamelCase } from '@hotjar/insights-common/lib/convert-string/toCamelCase';
import type { LoginResponseDto, LoginResponse } from './types';

export const loginResponseDtoToModel = (response: LoginResponseDto): LoginResponse =>
  keysToCamelCase(response);
